const pendingChanges = {
    text: {},
    image: {},
    youtube: {},
    document: {}
};

// НОВОЕ: Отдельное хранилище для File объектов (они не сериализуются)
const fileStorage = new Map();

export function getPendingChanges() {
    // Объединяем pending changes с файлами из fileStorage
    const result = {
        text: { ...pendingChanges.text },
        image: { ...pendingChanges.image },
        youtube: { ...pendingChanges.youtube },
        document: { ...pendingChanges.document }
    };

    // Добавляем файлы обратно к соответствующим изменениям
    for (const [key, file] of fileStorage.entries()) {
        const [type, tagId] = key.split(':');
        if (result[type] && result[type][tagId]) {
            result[type][tagId].file = file;
        }
    }

    return result;
}

export function updatePendingChanges(type, id, data, merge = false) {
    if (!pendingChanges[type]) {
        pendingChanges[type] = {};
    }

    // Извлекаем File объект если есть
    let fileToStore = null;
    let dataToStore = { ...data };

    if (data.file && data.file instanceof File) {
        fileToStore = data.file;
        delete dataToStore.file; // Убираем файл из основных данных
        console.log(`Storing file separately for ${type}:${id}:`, fileToStore.name, fileToStore.type);
    }

    if (merge && pendingChanges[type][id]) {
        pendingChanges[type][id] = {
            ...pendingChanges[type][id],
            ...dataToStore
        };
    } else {
        pendingChanges[type][id] = dataToStore;
    }

    // Сохраняем файл отдельно
    if (fileToStore) {
        const fileKey = `${type}:${id}`;
        fileStorage.set(fileKey, fileToStore);
        console.log(`File stored with key: ${fileKey}`);
    }

    notifyPendingChanges();
}

export function removePendingChange(type, id) {
    if (pendingChanges[type] && pendingChanges[type][id]) {
        delete pendingChanges[type][id];

        // Также удаляем файл если есть
        const fileKey = `${type}:${id}`;
        if (fileStorage.has(fileKey)) {
            fileStorage.delete(fileKey);
            console.log(`File removed for key: ${fileKey}`);
        }

        notifyPendingChanges();
    }
}

export function clearPendingChanges() {
    pendingChanges.text = {};
    pendingChanges.image = {};
    pendingChanges.youtube = {};
    pendingChanges.document = {};

    // Очищаем файловое хранилище
    fileStorage.clear();
    console.log('All pending changes and files cleared');

    notifyPendingChanges();
}

export function hasPendingChanges() {
    return Object.keys(pendingChanges.text).length > 0 ||
        Object.keys(pendingChanges.image).length > 0 ||
        Object.keys(pendingChanges.youtube).length > 0 ||
        Object.keys(pendingChanges.document).length > 0;
}

export function getPendingChangesCount() {
    return Object.keys(pendingChanges.text).length +
        Object.keys(pendingChanges.image).length +
        Object.keys(pendingChanges.youtube).length +
        Object.keys(pendingChanges.document).length;
}

// НОВАЯ ФУНКЦИЯ: Получить файл для конкретного изменения
export function getFileForChange(type, tagId) {
    const fileKey = `${type}:${tagId}`;
    const file = fileStorage.get(fileKey);

    if (file) {
        console.log(`Retrieved file for ${fileKey}:`, file.name, file.type);
        return file;
    }

    console.warn(`No file found for ${fileKey}`);
    return null;
}

function notifyPendingChanges() {
    const event = new CustomEvent('pendingChanges:updated', {
        detail: {
            count: getPendingChangesCount(),
            hasPending: hasPendingChanges()
        }
    });

    document.dispatchEvent(event);
}